import React from 'react';

import { useSelector } from 'react-redux';
import Fade from '@material-ui/core/Fade';
import Icons from 'consts/icons';
import AirSpaceTable from './airspace/AirSpaceTable';
import { SidebarMenuDetailsUseStyles } from './SidebarMenuDetailsUseStyles';

const SidebarMenuAirSpaceDetails = () => {
  const [items, setItems] = React.useState([]);
  const [details, setDetails] = React.useState('zones');
  const classes = SidebarMenuDetailsUseStyles();

  const useString = () => {
    const lang = useSelector(state => state.language);

    return lang;
  };
  const subtitles = useString().sidebar.airspace;

  React.useEffect(() => {
    setItems([
      {
        name: 'zones',
        icon: <Icons.Dashboard.Map />,
      },
      {
        name: 'corridors',
        icon: <Icons.Dashboard.Analytics />,
      },
    ]);
  }, []);

  return (
    <>
      <div className={`${classes.SidebarMenuDetails}__table`}>
        {items.map((item, index) => (
          <div key={index} className={`${classes.SidebarMenuDetails}__list`}>
            <div
              key={item.name}
              className={`${classes.SidebarMenuDetails}__list__item ${
                details === item.name ? 'active' : ''
              }`}
              onClick={() => setDetails(item.name)}
              aria-hidden="true"
            >
              <div
                className={`${classes.SidebarMenuDetails}__list__item__icon`}
              >
                {item.icon}
              </div>
              <span
                className={`${classes.SidebarMenuDetails}__list__item__text`}
              >
                {subtitles[`${item.name}_`]}
              </span>
            </div>
          </div>
        ))}
      </div>
      <Fade in={details !== null}>
        <div>
          <AirSpaceTable details={details} />
        </div>
      </Fade>
    </>
  );
};

export default SidebarMenuAirSpaceDetails;
